import React, { useState, useEffect } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { calculateProfitMargin } from "../../utils/profitCalculator";
import { useSelector } from "react-redux";
import { getCurrency } from "../../utils/helper";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

const ROI = ({ data, salesData, settingsData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [roi, setRoi] = useState(
    Number(data?.roi.substring(0, data?.roi.length - 1))
  );
  const [breakevenSalePrice] = useState(Number(data?.breakeven_sale_price));
  const [salesPrice, setSalesPrice] = useState(
    Number(data?.prices?.sale_price).toFixed(2)
  );
  const totalFees = useSelector((state) => state.globalStates.total_fees);
  const prices = useSelector((state) => state.globalStates.prices);
  const [costPrice, setCostPrice] = useState(0);
  const [profit, setProfit] = useState(
    calculateProfitMargin(salesPrice, costPrice, totalFees)[0]
  );

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (!isNaN(prices.cost_price)) {
      setCostPrice(Number(prices.cost_price || 0));
      // when cost price changes, reset the ROI to 100
      const calcRoi = 100;
      const calcProfit = parseFloat(
        (calcRoi / 100) * prices.cost_price
      ).toFixed(2);
      const calcSalesPrice = Number(
        +prices.cost_price + +calcProfit + +totalFees
      ).toFixed(2);
      setRoi(calcRoi);
      setSalesPrice(calcSalesPrice);
      setProfit(calcProfit);
    } else {
      setCostPrice(0);
    }
  }, [prices.cost_price, totalFees]);

  useEffect(() => {
    const roi = Number(data?.roi.substring(0, data?.roi.length - 1));
    const costPrice = Number(data?.prices?.cost_price);
    const amazonFees = Number(data?.total_fees?.total);
    const salesPrice = Number(data?.prices?.sale_price).toFixed(2);

    setRoi(roi);
    setSalesPrice(salesPrice);
    setProfit(calculateProfitMargin(salesPrice, costPrice, amazonFees)[0]);
  }, [data]);

  const changeHandler = (e, type) => {
    // if roi is changed then calculate the profit and sale price
    if (type === "roi") {
      let roiValue = e.target.value;
      roiValue = roiValue.replace("%", "");
      setRoi(roiValue);
      const calcProfit = parseFloat((roiValue / 100) * costPrice);
      const calcSalesPrice = Number(costPrice + calcProfit + totalFees).toFixed(
        2
      );
      setProfit(calcProfit.toFixed(2));
      setSalesPrice(calcSalesPrice);
    }
    // if profit is changed then calculate the roi and sale price
    else {
      let profitValue = e.target.value;
      profitValue = profitValue.replace(getCurrency(settingsData?.marketplace), "");
      profitValue = profitValue.replace(/[^0-9.]/g, "");
      if (isNaN(profitValue)) {
        profitValue = 0;
      }
      if (profitValue.length > 2) {
        const dollars = profitValue.slice(0, -2);
        const cents = profitValue.slice(-2);
        profitValue = `${dollars}.${cents}`;
      }
      setProfit(profitValue);
      profitValue = Number(profitValue);
      const calcRoi = parseInt((profitValue / costPrice) * 100);
      setRoi(calcRoi);
      const calcSalesPrice = Number(
        Number(costPrice) + profitValue + totalFees
      ).toFixed(2);
      setSalesPrice(calcSalesPrice);
    }
  };
  
  const profitCalculator = (roi) => {
    // calculate profit for a fixed roi and sale price
    return (roi / 100) * Number(costPrice);
  };

  const RoiPercents = [0, 10, 20, 25, 30, 40, 50, 75, 80, 100, 200];
  return (
    <div
      className="flex flex-col w-full text-white"
    >
      <div className="flex cursor-pointer items-center mb-4 justify-between"  onClick={toggleAccordion}>
          <div
            className="mr-1 text-primary text-md font-bold"
          >
            ROI
          </div>
          <div className="text-primary">
            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
          </div>
      </div>
      {isOpen && (
        <>
            <div
              className="flex justify-between mb-3 text-sm font-semibold bg-secondary-bg rounded-lg px-3 py-2"
            >
              <div className="w-1/4 text-center">ROI</div>
              <div className="w-1/4 text-center">Profit</div>
              <div className="w-1/4 text-center text-primary">Sale Price</div>
            </div>
            <div
              className="flex gap-2 items-center justify-between gap-x-3 text-sm text-primary"
            >
                  <input
                    type="text"
                    value={`${roi}%`}
                    onChange={(e) => changeHandler(e, "roi")}
                    // onBlur={resetValues}
                    className="text-center text-white font-semibold border border-primary rounded-lg bg-primary-bg p-1 w-full"
                  />
                  <input
                    type="text"
                    value={`${getCurrency(settingsData?.marketplace)}${profit}`}
                    // onChange={(e) => changeHandler(e, "profit")}
                    // onBlur={resetValues}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/[^0-9]/g, "");
                      e.target.value = `${getCurrency(settingsData?.marketplace)}${rawValue}`;
                      changeHandler(e, "profit");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === ".") {
                        e.preventDefault();
                      }
                    }}
                    className="text-center text-white font-semibold border border-primary rounded-lg bg-primary-bg p-1 w-full"
                  />
                  <input
                    type="text"
                    value={`${getCurrency(settingsData?.marketplace)}${salesPrice}`}
                    disabled
                    className="text-center text-primary font-semibold border border-primary rounded-lg bg-primary-bg p-1 w-full"
                  />
            </div>
            {RoiPercents.map((roiRow, index) => (
              <div
                key={index}
                className="flex items-center justify-between text-sm mt-2 bg-secondary-bg border border-primary/20 rounded-lg px-3 py-2"
              >
                <div className="w-1/4 text-center text-white">{roiRow}%</div>
                <div className="w-1/4 text-center text-white">
                  {getCurrency(settingsData?.marketplace) + profitCalculator(roiRow).toFixed(2)}
                </div>
                <div className="w-1/4 text-center text-primary">
                  {getCurrency(settingsData?.marketplace) +
                    (
                      Number(costPrice) +
                      profitCalculator(roiRow) +
                      totalFees
                    ).toFixed(2)}
                </div>
              </div>
            ))}
            <p className="text-sm text-left mt-1 text-white py-2">
              Based on your cost price of ${costPrice.toFixed(2)}
            </p>
        </>
      )}
    </div>
  );
};

export default ROI;
